<template>
  <div class="login">

    <div class="logoWrapper">
      <img src="@/assets/newdesignlogo.svg" />
      <p>Tempest</p>
    </div>

    <form class="loginInputs" @submit.prevent="signIn">
      <div class="login-input">
        <label for="username">E-Mail</label>
        <div class="input-container">
          <input type="email" placeholder="E-Mail" v-model="username" name="username" id="username"
          autocomplete="username email" inputmode="email" autocapitalize="false"
          spellcheck="false" ref="userButton"  @change="checkAutologin"/>
          <div class="emailIcon bgSvg"></div>
        </div>
      </div>

      <div class="login-input">
        <label for="password">Password</label>
        <div class="input-container">
          <input type="password" placeholder="Password" v-model="password"
          ref="passwordButton" name="password" @change="checkAutologin"
          autocomplete="current-password" id="password"/>
          <button @click="passwordToggle" class="passwordButton bgSvg"
          :class="{passwordTog : passwordVisible}" type="button"></button>
        </div>
      </div>

      <button class="loginCta" type="submit" :disabled="loading || buttonDisabled">
        <span v-if="loading === false">Login</span><loading-wheel v-else/>
      </button>
    </form>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify';
import { AmplifyEventBus } from 'aws-amplify-vue';
import store from '@/store/index';

import LoadingWheel from '../components/LoadingWheel.vue';

export default {
  name: 'Home',
  components:
    { LoadingWheel },
  data() {
    return {
      username: '',
      password: '',
      loading: false,
      passwordVisible: false,
      autologinUserTs: 0,
      autologinPassTs: 0,
    };
  },
  computed: {
    buttonDisabled() {
      if (this.username === '' || this.password === '') {
        return true;
      } return false;
    },
  },
  methods: {
    checkAutologin(e) {
      const nowTime = Date.now();
      if (e.target.id === 'username') this.autologinUserTs = nowTime;
      else if (e.target.id === 'password') this.autologinPassTs = nowTime;
      if (this.autologinUserTs && this.autologinPassTs
      && Math.abs(this.autologinUserTs - this.autologinPassTs) < 100) {
        if (this.username && this.password) this.signIn();
      }
    },
    passwordToggle() {
      if (this.$refs.passwordButton.type === 'password') {
        this.passwordVisible = true;
        this.$refs.passwordButton.type = 'text';
      } else {
        this.$refs.passwordButton.type = 'password';
        this.passwordVisible = false;
      }
    },
    async signIn() {
      try {
        this.loading = true;
        const previousEmail = localStorage.getItem('email');
        const user = await Auth.signIn(this.username, this.password);
        if (!user) {
          this.loading = false;
          return;
        } // We should do error handling here

        if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
          this.$router.push({ name: 'ChangePassword', params: { user } });
          return;
        }

        if (previousEmail !== user.username) {
          localStorage.removeItem('deviceSelected');
          localStorage.removeItem('appStats');
          this.$store.dispatch('loadStateFromLocalStorage');
        } else {
          console.log('[Debug] Same User!');
        }

        const jwt = user
          .getSignInUserSession()
          .getIdToken()
          .getJwtToken();
        store.commit('setToken', jwt);
        store.commit('setLoggedIn', true);
        localStorage.setItem('email', user.username);
        localStorage.setItem('loggedIn', store.state.user.loggedIn);
        AmplifyEventBus.$emit('authState', 'signedIn');
        this.loading = false;
        store.dispatch('googleAuth/checkAuthenticatedWithGoogle');
        this.$router.push({ name: 'Cameras' });
      } catch (err) {
        this.loading = false;
        console.log(err);

        if (err.code === 'UserLambdaValidationException' || err.code === 'NotAuthorizedException') {
          this.password = '';

          this.$store.dispatch('addNotification', {
            type: 'red',
            title: 'Incorrect username or password!',
            comment: 'Try again',
          });
        }
      }
    },
  },
  mounted() {
    this.$refs.userButton.focus();
  },
};
</script>
<style scoped>
.login-input {
  font-weight: bold;
  text-align: left;
}
.login-input label {
  margin-left: 16px;
  margin-bottom: 6px;
}
.login-input:first-of-type {
  margin-bottom: 34px;
}

input:-webkit-autofill{
  transition: background-color 5000000s ease-in-out 0s;
  -webkit-text-fill-color: var(--text) !important;

}
.input-container {
  display: flex;
  border-radius: var(--border-radius);
  background: var(--surface);

}
.passwordButton {
  background: transparent;
  width: 42px;
  height: 50px;
  background-image: url("data:image/svg+xml,%3Csvg width='24' height='10' viewBox='0 0 23 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.90909 1.90909C1.90909 1.90909 5.40909 5.90909 11.9091 5.90909C18.4091 5.90909 21.9091 1.90909 21.9091 1.90909M3.90909 3.55409L1.90909 5.90909M21.9091 5.90909L19.9131 3.55709M8.8231 5.58909L7.9091 8.40909M14.9721 5.59709L15.9091 8.40909' stroke='%23EAEBEC' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");

}
.emailIcon {
  width: 42px;
  height: 50px;
  background-image: url("data:image/svg+xml,%3Csvg width='24' height='20' viewBox='0 0 20 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.34107e-09 4.55467L9.68546 9.48C9.78261 9.52939 9.8905 9.55518 10 9.55518C10.1095 9.55518 10.2174 9.52939 10.3145 9.48L20 4.55556V13.1111C20.0001 13.849 19.7113 14.559 19.193 15.0953C18.6747 15.6317 17.9662 15.9538 17.2127 15.9956L17.0455 16H2.95455C2.19988 16 1.47379 15.7177 0.925245 15.211C0.376697 14.7042 0.0472715 14.0114 0.00454557 13.2747L6.34107e-09 13.1111V4.55467ZM2.95455 6.20019e-09H17.0455C17.8001 -4.83082e-05 18.5262 0.28227 19.0748 0.789041C19.6233 1.29581 19.9527 1.98862 19.9955 2.72533L20 2.88889V3.05244L10 8.13689L6.34107e-09 3.05244V2.88889C-4.94061e-05 2.15099 0.288686 1.44104 0.806974 0.904684C1.32526 0.368326 2.03381 0.046221 2.78727 0.00444455L2.95455 6.20019e-09Z' fill='%23EAEBEC'/%3E%3C/svg%3E%0A");
}
.passwordTog {
  background-image: url("data:image/svg+xml,%3Csvg width='24' height='20' viewBox='0 0 20 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.33929 8C7.33929 8.72894 7.60995 9.42802 8.09172 9.94346C8.57349 10.4589 9.22692 10.7485 9.90825 10.7485C10.5896 10.7485 11.243 10.4589 11.7248 9.94346C12.2065 9.42802 12.4772 8.72894 12.4772 8C12.4772 7.27106 12.2065 6.57198 11.7248 6.05654C11.243 5.5411 10.5896 5.25153 9.90825 5.25153C9.22692 5.25153 8.57349 5.5411 8.09172 6.05654C7.60995 6.57198 7.33929 7.27106 7.33929 8ZM19.8675 7.36687C17.6931 2.46626 14.4062 0 9.99999 0C5.59148 0 2.30689 2.46626 0.132451 7.36933C0.0452335 7.56691 0 7.78271 0 8.00123C0 8.21974 0.0452335 8.43554 0.132451 8.63313C2.30689 13.5337 5.59378 16 9.99999 16C14.4085 16 17.6931 13.5337 19.8675 8.63068C20.0442 8.23313 20.0442 7.77178 19.8675 7.36687ZM9.90825 12.319C7.67876 12.319 5.87131 10.3853 5.87131 8C5.87131 5.61472 7.67876 3.68098 9.90825 3.68098C12.1377 3.68098 13.9452 5.61472 13.9452 8C13.9452 10.3853 12.1377 12.319 9.90825 12.319Z' fill='%23EAEBEC'/%3E%3C/svg%3E%0A");
}
input {
  outline: none;
}

.login {
  overflow: hidden;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.logoWrapper {
  margin-top: 42px;
  display: flex;
}

.logoWrapper > *:first-child {
  margin-right: 14px;
}

.logoWrapper p {
  font-style: normal;
  font-weight: 500;
  font-size: 30px;

}

input[type=text],
input[type=password],
input[type=email] {
  height: 50px;
  width: 208px;
  background: transparent;
  border: none;
  box-sizing: border-box;
  padding: 16px 0px 16px 16px;
  font-size: 16px;
}
input::placeholder {
  color: #eaebecab;
  font-size: 16px;
}

.loginInputs {
  margin-top: 94px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.loginCta {
  margin-top: 64px;
  transition: all 0.3s;
  height: 60px;
  width: 168px;
  background: var(--success);
  border: none;
  border-radius: var(--border-radius);
  font-size: 1.125em;
  font-weight: 600;
}

</style>
